import React from 'react';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import { classes, style } from 'typestyle';
import { spacing } from '../../../theme/spacing';
import { rebrand } from '../../../theme/color';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { important, px } from 'csx';
import { mediaSmallTablet } from '../utilities/mediaQueries';

interface AutomatedClaimsClearanceModalProps {
  show: boolean;
  onRequestClose(): void;
}

export const AutomatedClaimsClearanceModal: React.FC<AutomatedClaimsClearanceModalProps> = ({
  show,
  onRequestClose,
}) => {
  return (
    <ScrollableOverlay className={styles.wrapper} show={show} onRequestClose={onRequestClose}>
      <div className={overlayStyles.header} style={{ padding: '0 0 24px' }}>
        <h3 className={classes(styles.heading, overlayStyles.title)}>Automated claims clearance</h3>
      </div>
      <div className={styles.body}>
        <p className={styles.description}>
          Claims on these tracks should be cleared within 30 minutes automatically by our software. In some rare cases,
          these may take a little longer to clear - so keep an eye on the claims statuses in the Videos & Claims tab of
          your account.
        </p>
      </div>
    </ScrollableOverlay>
  );
};

const styles = {
  description: style({
    fontSize: '16px',
    marginBottom: spacing.LARGE,
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    textAlign: 'center',
    $nest: {
      '& > p': {
        margin: '0 0 1.5rem',
        textAlign: 'left',
        lineHeight: px(24),
      },
    },
  }),
  wrapper: style(
    mediaSmallTablet({
      padding: important('24px'),
    }),
    { display: 'block', maxWidth: px(440) }
  ),
  heading: style({
    fontSize: px(24),
  }),
};
